import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Container, Grid } from '@material-ui/core'
import globalStyles from '../../styles/global-styles.module.scss'
import { gql, useQuery } from '@apollo/client'
import ArticleCard from '../cards/article'
import ListingStyles from './listing-styles'
import Loading from '../loading'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

const BLOG_POSTS = gql`
  query getBlogArticles($locale: String, $where: JSON) {
    blogArticles(locale: $locale, where: $where, limit: 50, sort: "updated_at:desc") {
      created_at
      updated_at
      title
      slug
      standfirst
      featuredImage {
        alternativeText
        ext
        url
      }
      categories {
        slug
        name
      }
      author {
        id
        email
      }
      tags {
        name
      }
    }
  }
`
const BLOG_CATEGORIES = gql`
  query getBlogCategories($locale: String, $where: JSON) {
    blogCategories(locale: $locale, where: $where) {
      articles(limit: 3, sort: "updated_at:desc") {
        created_at
        updated_at
        title
        slug
        standfirst
        featuredImage {
          alternativeText
          ext
          url
        }
        categories {
          slug
          name
        }
        author {
          id
          email
        }
        tags {
          name
        }
      }
    }
  }
`
const BlogListing = ({ category, columns, count, searchString, withLarge }) => {
  const router = useRouter()
  const { t, i18n } = useTranslation()
  const [filteredData, setFilteredData] = useState([])
  let where = {}
  let GQL_QUERY
  if (category.slug === '') {
    GQL_QUERY = BLOG_POSTS
  } else {
    GQL_QUERY = BLOG_CATEGORIES
    where['slug'] = category.slug
  }
  const { loading, error, data } = useQuery(GQL_QUERY, {
    variables: {
      where,
      locale: i18n.language,
    },
  })

  useEffect(() => {
    if (searchString && searchString.length > 3) {
      if (data.blogCategories && data.blogCategories.length > 0) {
        setFilteredData(
          data.blogCategories[0].articles.filter((article) => {
            return (
              article.title
                .toLowerCase()
                .includes(searchString.toLowerCase()) ||
              article.standfirst
                .toLowerCase()
                .includes(searchString.toLowerCase())
            )
          })
        )
      } else {
        setFilteredData(
          data.blogArticles.filter((article) => {
            return (
              article.title
                .toLowerCase()
                .includes(searchString.toLowerCase()) ||
              article.standfirst
                .toLowerCase()
                .includes(searchString.toLowerCase())
            )
          })
        )
      }
    } else if (data) {
      if (data.blogCategories && data.blogCategories.length > 0)
        setFilteredData(data.blogCategories[0].articles)
      else setFilteredData(data.blogArticles)
    }
  }, [searchString, data])

  const classes = ListingStyles({ columns: columns })
  if (error) return <React.Fragment />
  return (
    <Container maxWidth={'lg'}>
      {loading && <Loading />}
      {filteredData && filteredData.length > 0 && (
        <div className={classes.listing}>
          {filteredData.map((article, i) => {
            const className = i === 0 ? 'first' : ''
            return (
              <ArticleCard
                article={article}
                className={className}
                key={i}
                modulus={withLarge && i % 2 === 1}
              />
            )
          })}
        </div>
      )}
      {/*{data && data.hasOwnProperty('blogArticles') && (*/}
      {/*  <div className={classes.listing2}>*/}
      {/*    {data.blogArticles.map((article, i) => {*/}
      {/*      const className = '' //i === 0 ? 'first' : ''*/}
      {/*      return (*/}
      {/*        <ArticleCard*/}
      {/*          alt*/}
      {/*          article={article}*/}
      {/*          className={className}*/}
      {/*          key={i}*/}
      {/*          modulus={!!(i % 2)}*/}
      {/*        />*/}
      {/*      )*/}
      {/*    })}*/}
      {/*{!count && (*/}
      {/*  <React.Fragment>*/}
      {/*    {data.blogArticles.map((article, i) => {*/}
      {/*      return <ArticleCard alt article={article} key={i} />*/}
      {/*    })}*/}
      {/*  </React.Fragment>*/}
      {/*)}*/}
      {/*  </div>*/}
      {/*)}*/}
      {/*{!count && data && data.hasOwnProperty('blogArticles') && (*/}
      {/*  <div className={classes.loadMore}>*/}
      {/*    <hr />*/}
      {/*    <button>Load More Stories</button>*/}
      {/*    <hr />*/}
      {/*  </div>*/}
      {/*)}*/}
    </Container>
  )
}
BlogListing.propTypes = {
  category: PropTypes.object.isRequired,
  columns: PropTypes.number.isRequired,
  count: PropTypes.number,
  searchString: PropTypes.string,
  withLarge: PropTypes.bool,
}
export default BlogListing
